import {
    GET_CUSTOMER_PAYMENT_DETAIL_ERROR, GET_CUSTOMER_PAYMENT_DETAIL_SUCCESS, GET_CUSTOMER_PAYMENT_DETAIL_REQUEST
} from "../actions/types"

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_CUSTOMER_PAYMENT_DETAIL_REQUEST:
            return {
                loading: true,
            };
        case GET_CUSTOMER_PAYMENT_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_CUSTOMER_PAYMENT_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                payload
            };
        default:
            return state;
    }
}